<app-picker
  #_pickerComponent
  (pickerDialogAfterClosedEvent)="pickerDialogAfterClosedEventHandler()"
  (selectElement)="selectElement($event)"
  (updateState)="updateState($event)"
  (uuidSelected)="uuidSelectedHandler($event)"
  [addButtonLabel]="'Changer de laboratoire'"
  [addIconButtonTooltip]="'Sélectionner un laboratoire'"
  [autoCompleteResultList]="autoCompleteResultList"
  [elements]="elements"
  [existenceFlag]="existenceFlag"
  [highlightCol1LabelFlag]="true"
  [loadedFlag]="loadedFlag"
  [matLabel]="'Saisir un laboratoire'"
  [multipleSelectionFlag]="false"
  [showInputFlag]="false"
  [state]="pickerState"
  [textFilterDefaultValue]="textFilterDefaultValue"
  [totalCount]="totalCount"
></app-picker>
